import React from 'react';
import PropTypes from 'prop-types';
import { getCriticalText } from '../../../helpers/new-trip-details-helper';
import Icon from '../../directives/Icon/Icon';
import * as Styled from './Style';
const SegmentCriticalInfo = ({
  children,
  criticalInfo,
  skipMargins
}) => /*#__PURE__*/React.createElement(Styled.CriticalInfo, {
  skipMargins: skipMargins
}, /*#__PURE__*/React.createElement(Styled.CriticalIcon, null, /*#__PURE__*/React.createElement(Icon, {
  name: "info"
})), /*#__PURE__*/React.createElement(Styled.CriticalText, null, children || /*#__PURE__*/React.createElement("div", {
  dangerouslySetInnerHTML: {
    __html: getCriticalText(criticalInfo)
  }
})));
SegmentCriticalInfo.propTypes = {
  criticalInfo: PropTypes.string
};
export default SegmentCriticalInfo;